import {PaginaLogada} from "../../componentes";
import React, {useEffect, useMemo, useState} from "react";
import {useParams} from "react-router-dom";
import {
  exibirMensagemErro,
  exibirMensagemSucesso,
  formatarDinheiroItl,
  HttpVerbo,
  xfetch
} from "../../util";
import Swal from "sweetalert2";
import CadastrarAcaoEixo from "../../componentes/cadastrar-acao-eixo";
import {
  BotaoAlterar,
  BotaoFechar,
  BotaoMantine,
  BotaoSalvar
} from '../../componentes/botao/botao-mantine';
import {COL_RESP_3, COL_RESP_6, COR, FONTE_FUNDO_A_FUNDO, ICONE} from '../../config/constantes/constantes-mantine';
import {IconShoppingBagPlus} from "@tabler/icons-react";
import {Item} from "../../tipos/item";
import {Meta} from "../../tipos/meta";
import SelectFetchMantine from "../../componentes/form/select-fetch-mantine";
import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Card,
  Center,
  Grid,
  Group,
  Modal,
  NumberInput, Select,
  TextInput,
  Title,
  Tooltip
} from "@mantine/core";
import {MantineReactTable, MRT_ColumnDef} from "mantine-react-table";
import {MRT_Localization_PT_BR} from "mantine-react-table/locales/pt-BR";
import CardPadrao from "../../componentes/card/card-padrao";
import {useDisclosure} from "@mantine/hooks";
import DinheiroInput from "../../componentes/form/dinheiro-input";
import {displayFlagStyle} from "../../util/util";

export default function MetaDetalhes() {

  const parametros = useParams()
  const [meta, setMeta] = useState(new Meta())
  const [isCarregando, setIsCarregando] = useState(false)
  const [itens, setItens] = useState(new Array<Item>());
  const [item, setItem] = useState(new Item())
  const [itemModal, setItemModal] = useState(new Item())
  const [isFundoaFundo, setIsFundoaFundo] = useState(false)
  const [metas, setMetas] = useState(new Array<Meta>())
  const [metaTransferencia, setMetaTransferencia] = useState(-1)
  const [modalNovoItem, {open: openModalNovoItem, close: closeModalNovoItem}] = useDisclosure(false);
  const [modalTransferencia, {open: openModalTransferencia, close: closeModalTransferencia}] = useDisclosure(false);

  function armazenarItem(e: any) {
    e.preventDefault()

    if (!validaItem()) {
      return
    }
    setItens([...itens, item])
    item.idMeta = meta.id

    setIsCarregando(true)
    xfetch(`/meta/${meta.id}/item`, item, HttpVerbo.POST)
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso("Item cadastrado com sucesso")
        setItem(new Item());
      })
      .finally(() => {
        closeModalNovoItem()
        setIsCarregando(false)
        carregaMeta()
      })
  }

  function validaItem() {
    if (item.nome === '') {
      exibirMensagemErro("Preencha o nome do item")
      return false
    }

    if (item.quantidade === 0) {
      exibirMensagemErro("Preencha a quantidade do item")
      return false
    }

    if (item.valorCotado === 0) {
      exibirMensagemErro("Preencha o valor empenhado")
      return false
    }

    if (!isFundoaFundo && (item.naturezaDespesa.id === 0)) {
      exibirMensagemErro("Preencha a natureza da despesa")
      return false
    }

    if (isFundoaFundo && !item.idAcao) {
      exibirMensagemErro("Uma ação precisa ser informada")
      return false
    }

    return true
  }

  const excluirItem = (i: Item) => {
    const dados = "<b>ID:</b> " + i.id + "<br><b>Item: </b>" + i.nome + "<br>"
    // @ts-ignore
    Swal.fire({
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      },
      title: 'Tem certeza que deseja excluir o item?',
      html: dados + "Essa ação não poderá ser desfeita!",
      icon: 'danger',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: '<i class="bi bi-trash3-fill me-2"></i>Excluir',
      cancelButtonText: '<i class="bi bi-x-circle me-2"></i> Fechar'
    }).then((result) => {
      console.log(i)
      if (result.isConfirmed) {
        xfetch(`/item/${i.id}/delete`, {}, HttpVerbo.POST)
          .then(res => res.json())
          .then(dados => {
            carregaMeta()
            exibirMensagemSucesso('Item excluido com sucesso.')
          })
          .finally(() => setIsCarregando(false))
      }
    })
  }

  function transferirItem(e: any) {

    e.preventDefault()

    const dados = {
      idItem: itemModal.id, idMetaOrigem: meta.id, idMeta: metaTransferencia
    }

    xfetch('/item/transferirItem', dados, HttpVerbo.POST)
      .then(res => res.json())
      .then(dados => {
        carregaMeta()
        exibirMensagemSucesso("Iten transferido com sucesso")
        closeModalTransferencia()
      })
      .finally(() => setIsCarregando(false))
  }

  const carregaMeta = () => {
    const id = parametros.idMeta
    setIsCarregando(true)
    xfetch('/projeto/meta/' + id, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(json => {
        setMeta(json)
        setItens(json.itens)
        setIsFundoaFundo(json.idFonteRecurso === FONTE_FUNDO_A_FUNDO)
        setIsCarregando(false)
      })
    // .catch(e => setIsCarregando(false) & exibirMensagemErro("Erro ao carregar meta - "+ e))
  }

  function exibirModalTransferirItem(item: Item) {
    setItemModal(item)
    openModalTransferencia()
  }

  function carregaMetasDoProjeto() {
    setIsCarregando(true)
    xfetch(`/projeto/${parametros.idProjeto}/metas`, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => {
        setMetas(dados)
      })
      .finally(() => setIsCarregando(false))
  }


  function selecionarMetaTransferencia(e: any) {
    setMetaTransferencia(e)
  }

  function alterarMeta(e: any) {
    e.preventDefault();
  }

  const colunasFundo = useMemo<MRT_ColumnDef<Item>[]>(() => [
    {
      accessorKey: 'nome',
      header: 'Nome',
      size: 600,
      Cell: ({renderedCellValue, row}) => (
        <Anchor href={`/projeto/${parametros.idProjeto}/meta/${parametros.idMeta}/item/${row.original.id}`}>
          {renderedCellValue}
        </Anchor>
      ),
      filterVariant: 'autocomplete',
    },
    {
      accessorKey: 'forca.sigla',
      header: 'Forca',
      size: 50,
      Cell: ({renderedCellValue, row}) => (
        <Tooltip label={row.original.forca.nome}>
          <Badge color={row.original.forca.cor}>
            {renderedCellValue}
          </Badge>
        </Tooltip>
      ),
      filterVariant: 'multi-select',

    },
    {
      accessorKey: 'quantidade',
      header: 'Quantidade',
      // filterVariant: 'range-slider',
      // filterFn: 'betweenInclusive',
      // mantineFilterRangeSliderProps: {
      //     step: 50,
      // },
    },
    {
      accessorKey: 'valorCotado',
      header: 'Valor Unitário',
      Cell: ({cell}) => formatarDinheiroItl(cell.getValue()),
      filterVariant: 'range-slider',
      filterFn: 'betweenInclusive',
      mantineFilterRangeSliderProps: {
        step: 500,
        label: (value) => formatarDinheiroItl(value)
      },
    },
    {
      accessorKey: 'valorExecutado',
      header: 'Valor Executado',
      Cell: ({cell}) => formatarDinheiroItl(cell.getValue()),
      filterVariant: 'range-slider',
      filterFn: 'betweenInclusive',
      mantineFilterRangeSliderProps: {
        step: 500,
        label: (value) => formatarDinheiroItl(value)
      },
    },
    {
      accessorKey: 'acaoEixo.numero',
      header: 'Acão Eixo',
      size: 50,
    },
    {
      id: 'acaoFundo',
      header: 'Ação',
      size: 50,
      enableColumnActions: false,
      Cell: ({cell}) => {
        return (
          <Group wrap="nowrap" gap="lg">
            <Tooltip label={"Excluir"}>
              <ActionIcon
                aria-label="Excluir"
                color={COR.PERIGO}
                onClick={() => excluirItem(cell.row.original)}>
                <ICONE.EXCLUIR/>
              </ActionIcon>
            </Tooltip>
          </Group>
        )
      },
    },
  ], [parametros.idProjeto, parametros.idMeta])

  const colunasConvenio = useMemo<MRT_ColumnDef<Item>[]>(() => [
    {
      accessorKey: 'nome',
      header: 'Nome',
      size: 400,
      Cell: ({renderedCellValue, row}) => (
        <Anchor href={`/projeto/${parametros.idProjeto}/meta/${parametros.idMeta}/item/${row.original.id}`}>
          {renderedCellValue}
        </Anchor>
      ),
      filterVariant: 'autocomplete',
    },
    {
      accessorKey: 'quantidade',
      header: 'Quantidade',
      filterVariant: 'range-slider',
      filterFn: 'betweenInclusive',
    },
    {
      accessorKey: 'valorCotado',
      header: 'Valor Cotado',
      Cell: ({cell}) => formatarDinheiroItl(cell.getValue()),
      filterVariant: 'range-slider',
      filterFn: 'betweenInclusive',
      mantineFilterRangeSliderProps: {
        step: 500,
        label: (value) => formatarDinheiroItl(value)
      },
    },
    {
      accessorKey: 'valorExecutado',
      header: 'Valor Executado',
      Cell: ({cell}) => formatarDinheiroItl(cell.getValue()),
      filterVariant: 'range-slider',
      filterFn: 'betweenInclusive',
      mantineFilterRangeSliderProps: {
        step: 500,
        label: (value) => formatarDinheiroItl(value)
      },
    },
    {
      accessorKey: 'dataExecucao',
      header: 'Data Execução',
      Cell: ({cell}) => {
        return cell.getValue() != null ? new Date(cell.getValue<Date>()).toLocaleDateString() : ""
      },
      filterVariant: 'date-range',
    },
    {
      id: 'acaoConvenio',
      header: 'Ações',
      enableColumnActions: false,
      Cell: ({cell}) => {
        return (
          <Group wrap="nowrap" gap="lg">
            <Tooltip label={"Transferir"}>
              <ActionIcon
                aria-label="Transferir"
                color={COR.ALERTA}
                onClick={() => exibirModalTransferirItem(cell.row.original)}>
                <ICONE.TRANSFERIR/>
              </ActionIcon>
            </Tooltip>
            <Tooltip label={"Excluir"}>
              <ActionIcon
                aria-label="Excluir"
                color={COR.PERIGO}
                onClick={() => excluirItem(cell.row.original)}>
                <ICONE.EXCLUIR/>
              </ActionIcon>
            </Tooltip>
          </Group>
        )
      },
    },
  ], [])

  const tabelaFundo = (
    <MantineReactTable
      data={itens}
      columns={colunasFundo}
      enablePagination
      enableFacetedValues
      localization={MRT_Localization_PT_BR}
    />)

  const tabelaConvenio = (
    <MantineReactTable
      data={itens}
      columns={colunasConvenio}
      enablePagination
      enableFacetedValues
      localization={MRT_Localization_PT_BR}
    />)

  const displayFundoaFundo = {display: isFundoaFundo ? "" : "none"}
  const displayConvenio = {display: !isFundoaFundo ? "" : "none"}
  const dataSelectModal = metas?.length > 0 ? metas.map((m: any, k) => {
    return {key: k, value: m.id.toString(), label: m.descricao}
  }) : [];

  useEffect(() => {
    carregaMeta()
    carregaMetasDoProjeto()
  }, [])

  function fecharModalNovoItem() {
    setItem(new Item())
    closeModalNovoItem()
  }

  return (
    <PaginaLogada titulo="Detalhes da meta" isCarregando={isCarregando} botaoVoltar
                  voltarPara={"/projeto/" + parametros.idProjeto}>
      <CardPadrao>
        <Grid p={"md"}>
          <Grid.Col span={12}>
            <TextInput
              label={"Descrição"}
              value={meta.descricao}
              name='descricao'
              readOnly
              placeholder="Descrição da meta"/>
          </Grid.Col>
          <Grid.Col span={COL_RESP_3} style={displayFundoaFundo}>
            <TextInput
              label={"Valor de custeio"}
              value={formatarDinheiroItl(meta.valorCusteio)}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3} style={displayFundoaFundo}>
            <TextInput
              label={"Valor de capital"}
              value={formatarDinheiroItl(meta.valorCapital)}
            />
          </Grid.Col>

          <Grid.Col span={COL_RESP_3} style={displayConvenio}>
            <TextInput
              label={"Valor de estimado"}
              value={formatarDinheiroItl(meta.valorEstimado)}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3} style={displayConvenio}>
            <TextInput
              label={"Força"}
              value={meta?.forca?.nome}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3} style={displayConvenio}>
            <DinheiroInput
              label={"Economicidade"}
              readOnly
              value={(meta.valorEstimado - meta.valorTotal)}
            />
          </Grid.Col>

          <Grid.Col span={COL_RESP_3} style={{alignSelf: "self-end", displayFundoaFundo}}>
            <BotaoAlterar onClick={alterarMeta}/>
          </Grid.Col>
        </Grid>
      </CardPadrao>

      <Box mt={30}>
        <CadastrarAcaoEixo setIsCarregando={setIsCarregando} meta={meta}/>
      </Box>

      <Card mt={50}>
        <Card.Section inheritPadding withBorder py={"md"} mb={"md"}>
          <Group>
            <Title order={3}>Itens</Title>
            <BotaoMantine size={"sm"} ml={20} icone={IconShoppingBagPlus} onClick={openModalNovoItem}>
              Adicionar Item
            </BotaoMantine>
          </Group>
        </Card.Section>

        {isFundoaFundo ? tabelaFundo : tabelaConvenio}

      </Card>

      <Modal opened={modalTransferencia} onClose={closeModalTransferencia} size={"lg"}
             title={"Transferir - " + itemModal.nome}>
        <Select my={30}
                label={"Meta"}
                description={"Transferir para"}
                data={dataSelectModal}
                onChange={selecionarMetaTransferencia}
        />
        <Center>
          <BotaoFechar m={5} onClick={closeModalTransferencia}/>
          <BotaoMantine m={5} color={COR.ALERTA} icone={ICONE.TRANSFERIR}
                        onClick={transferirItem}>Transferir</BotaoMantine>
        </Center>
      </Modal>

      <Modal opened={modalNovoItem} onClose={fecharModalNovoItem} size="lg" title={"Novo Item"}>
        <Grid>
          <Grid.Col span={12}>
            <TextInput
              label={"Nome"}
              name="nome"
              autoComplete="off"
              placeholder="Nome item"
              value={item.nome}
              onChange={(e) => setItem({...item, nome: e.target.value.toString().toUpperCase()})}/>
          </Grid.Col>
          <Grid.Col span={12}>
            <NumberInput
              label={"Quantidade"}
              name="quantidade"
              placeholder="Quantidade"
              value={item.quantidade}
              onChange={(e) => setItem({...item, quantidade: parseInt(e.toString())})}/>
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label={"Número Empenho"}
              placeholder="Número do empenho"
              autoComplete="off"
              value={item.numeroEmpenho}
              onChange={(e) => setItem({...item, numeroEmpenho: e.target.value.toString().toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label={"Número Nota Fiscal"}
              placeholder="Número da nota fiscal"
              autoComplete="off"
              value={item.numeroNotaFiscal}
              onChange={(e) => setItem({...item, numeroNotaFiscal: e.target.value.toString().toUpperCase()})}
            />
          </Grid.Col>
        </Grid>
        {/* ======== Convênio======  */}
        <Grid style={displayFlagStyle(!isFundoaFundo)}>
          <Grid.Col span={12}>
            <TextInput
              label={"Número E-DOC"}
              placeholder="Número E-DOC"
              autoComplete="off"
              value={item.numeroEdoc}
              onChange={(e) => setItem({...item, numeroEdoc: e.target.value.toString().toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_6}>
            <SelectFetchMantine
              label={"Natureza Despesa"}
              placeholder='Selecione a natureza'
              url='/naturezaDespesa'
              onChange={(e: any) => setItem({...item, naturezaDespesa: e})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_6}>
            <SelectFetchMantine
              label={"Convenente"}
              placeholder="Convenente"
              url='/convenente'
              onChange={(v: any) => setItem({...item, idConvenente: v})}/>

          </Grid.Col>
        </Grid>
        {/* ======== Fundo a Fundo======  */}
        <Grid style={displayFlagStyle(isFundoaFundo)}>
          <Grid.Col span={12}>
            <SelectFetchMantine
              label={"Ação"}
              onChange={(e) => setItem({...item, idAcao: Number(e)})}
              url={'/meta/' + meta.id + '/acao'} placeholder='Selecione a ação'/>
          </Grid.Col>
          <Grid.Col span={12}>
            <SelectFetchMantine
              label={"Força"}
              onChange={(e) => setItem({...item, idForca: Number(e)})}
              url='/forca' placeholder='Selecione a força'/>
          </Grid.Col>
          <Grid.Col span={12}>
            <SelectFetchMantine
              label={"Conta"}
              onChange={(e) => setItem({...item, idConta: Number(e)})}
              url='/conta/select'
              placeholder='Selecione a conta'
              ids={[meta.idContaCusteio, meta.idContaCapital]}
            />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={COL_RESP_6}>
            <DinheiroInput
              label={isFundoaFundo ? "Valor Unitário Empenhado" : "Valor Unitário Cotado"}
              placeholder={isFundoaFundo ? "Valor Unitário Empenhado" : "Valor Unitário Cotado"}
              value={item.valorCotado}
              onChange={(e) => setItem({...item, valorCotado: Number(e)})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_6}>
            <DinheiroInput
              label={"Valor Unitário Executado"}
              placeholder="Valor unitário executado"
              value={item.valorExecutado}
              onChange={(e) => setItem({...item, valorExecutado: Number(e)})}/>
          </Grid.Col>
        </Grid>
        <Center mt={50}>
          <BotaoSalvar m={5} onClick={armazenarItem}/>
          <BotaoFechar m={5} onClick={fecharModalNovoItem}/>
        </Center>
      </Modal>
    </PaginaLogada>);
}
